export const CustomerData = {
    data() {
        return {}
    },
    methods: {
        // 客户列表
        GetCustomerData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/customer',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 客户来源
        GetSourceData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/customer_source',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 客户类型
        GetTypeData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/customer_type',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 客户级别
        GetLevelData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/customer_level',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 沟通方式
        GetCommunicationData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/communication',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }
    }
}
